import { Icon } from "@iconify/react/dist/iconify.js";
import Container from "@/Components/Grid/Container";
import { ApartmentModel } from "@/types/models/apartment";

import IconElevator from "@resources/show-apartment/amenities/elevator.png?format=webp&quality=90&imagetools";

const amenities = [
    "Mieszkanie wykończone pod klucz - gotowe do zamieszkania",
    "Wysokiej jakości materiały i nowoczesne wnętrza",
    "Ogrzewanie miejskie",
    "Własny ogród – prywatna przestrzeń do relaksu",
    "Nowoczesne części wspólne",
];

const badges = [
    {
        key: "turnkey",
        icon: null as string | null,
        iconify: "hugeicons:key-01",
        label: (
            <>
                Wykończone
                <br />
                pod klucz
            </>
        ),
    },
    {
        key: "garden",
        icon: null as string | null,
        iconify: "hugeicons:plant-01",
        label: "Ogród",
    },
    {
        key: "elevator",
        icon: IconElevator,
        iconify: null as string | null,
        label: "Winda",
    },
];

export const StandardAmenitiesSection = ({
    apartment,
}: {
    apartment: ApartmentModel;
}) => {
    const layout = apartment.get_attachment?.layout;
    const layoutFormat = layout?.split(".").pop();
    const layoutWebp = layout?.replace(/\.[^.]+$/, ".webp");
    const layoutOriginal = layout
        ? `${layout.replace(/\.[^.]+$/, "")}.${layoutFormat}`
        : undefined;

    return (
        <section className="py-14 lg:py-18">
            <Container>
                <div className="flex flex-col xl:flex-row items-center gap-10 xl:gap-20">
                    <div className="w-full xl:w-[52%] shrink-0">
                        {layout ? (
                            <picture>
                                <source
                                    srcSet={layoutWebp}
                                    type="image/webp"
                                />
                                <source
                                    srcSet={layoutOriginal}
                                    type={`image/${layoutFormat}`}
                                />
                                <img
                                    src={layout}
                                    alt={`Rzut mieszkania ${apartment.name}`}
                                    className="w-full h-auto object-contain"
                                    loading="lazy"
                                />
                            </picture>
                        ) : (
                            <Icon
                                icon="clarity:image-line"
                                width={220}
                                className="mx-auto text-secondary"
                            />
                        )}
                    </div>

                    <div className="w-full xl:flex-1 bg-primary/5 rounded-xl p-8 flex flex-col gap-5">
                        <h2 className="text-primary text-h4 leading-h4 font-extrabold tracking-[0.6px]">
                            Standard i udogodnienia
                        </h2>

                        <ul className="flex flex-col gap-3">
                            {amenities.map((item) => (
                                <li
                                    key={item}
                                    className="flex gap-2 items-center"
                                >
                                    <span className="size-4 shrink-0 rounded-full bg-alert flex items-center justify-center">
                                        <Icon
                                            icon="simple-line-icons:check"
                                            width={10}
                                            height={10}
                                            className="text-white"
                                        />
                                    </span>
                                    <p className="text-text text-p leading-p tracking-[0.45px]">
                                        {item}
                                    </p>
                                </li>
                            ))}
                        </ul>

                        <div className="flex flex-wrap gap-5 maxMd:justify-center">
                            {badges.map((badge) => (
                                <div
                                    key={badge.key}
                                    className="bg-white rounded-xl flex items-center gap-5 p-4 maxMd:justify-center"
                                >
                                    {badge.iconify ? (
                                        <Icon
                                            icon={badge.iconify}
                                            width={40}
                                            height={40}
                                            className="text-primary shrink-0"
                                        />
                                    ) : (
                                        <img
                                            src={badge.icon!}
                                            alt=""
                                            className="h-10 w-auto object-contain shrink-0"
                                        />
                                    )}
                                    <p className="text-primary text-[16px] leading-6 font-extrabold tracking-[0.08px] uppercase text-center">
                                        {badge.label}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};
